import classNames from "classnames"
import { Button } from "web/components"
import {
  ArrowUpOnSquareIcon,
  ArrowDownOnSquareStackIcon,
  ArrowPathIcon,
  UserGroupIcon,
} from "@heroicons/react/16/solid"

function ActionButton({ Icon, onClick, text, className, disableAfterClick }) {
  return (
    <span className={className}>
      <Button
        variant="tertiary_default"
        size="small"
        onClick={onClick}
        disableAfterClick={disableAfterClick}
      >
        <span className="mr-1 size-4">
          <Icon />
        </span>
        <span className="text-xs">{text}</span>
      </Button>
    </span>
  )
}

function ResetButton({ onViewReset }) {
  return (
    <ActionButton Icon={ArrowPathIcon} text="Reset" onClick={onViewReset} />
  )
}

function SaveAsButton({ onViewSaveAs }) {
  return (
    <ActionButton
      Icon={ArrowDownOnSquareStackIcon}
      text="Save As"
      onClick={onViewSaveAs}
      className="hidden md:block"
    />
  )
}

function UpdateButton({ onViewUpdate, disableAfterClick }) {
  return (
    <ActionButton
      onClick={onViewUpdate}
      Icon={ArrowUpOnSquareIcon}
      text="Update"
      className="hidden md:block"
      disableAfterClick={disableAfterClick}
    />
  )
}

export default function ViewActions({
  view,
  onViewReset,
  onViewUpdate,
  onViewSaveAs,
}) {
  const isSharedView = ["teams", "account"].includes(view.shared_with)
  const isModifiedSharedView = isSharedView && view.is_modified
  const isView = view.type === "view"

  return (
    <div className="flex items-center space-x-2">
      {isSharedView && (
        <div className="size-4 text-gray-400" title={view.shared_message}>
          <UserGroupIcon />
        </div>
      )}
      <div
        className={classNames("flex items-center", {
          "rounded-md bg-yellow-100": isModifiedSharedView,
        })}
      >
        {view.is_modified && <ResetButton onViewReset={onViewReset} />}
        {view.userCan("update") && (
          <UpdateButton
            onViewUpdate={onViewUpdate}
            disableAfterClick={isView}
          />
        )}
        {view.userCan("save") && <SaveAsButton onViewSaveAs={onViewSaveAs} />}
      </div>
    </div>
  )
}
